const parseAffiliate = (affiliate) => {
  const values = affiliate.trim().split('-');

  // The url does not create key:value pairs for this info
  // so if the template for it is changed, this needs to be updated
  // as well.
  return {
    name: values[0] || null,
    id: values[1] || null,
    type: values[2] || null,
  };
}


// Based on the tracking URL set up in Impact: https://app.impact.com/secure/advertiser/tracking-settings/gateway-trackingsettings-flow.ihtml?execution=e2s1
// If this gets changed, it risks affecting this logic.
export const parseAffiliateURL = () => {
  const campaign = new URLSearchParams(window.location.search).get('utm_campaign') || '';

  const source = new URLSearchParams(window.location.search).get('utm_source') || '';

  if (!campaign || !source) return null;

  if (source !== 'impact') return null;

  /* 
  * UTM campaign returns the name of the affiliate along 
  * with other information, we'll want to parse that out.
  * All campaign values are - separated, so we'll use that
  */
  return parseAffiliate(decodeURI(campaign));
}

export const getAffiliateCookie = () => {
  const decodedCookies = decodeURI(document.cookie);
  const cookies = decodedCookies.split(';');

  for (let i = 0; i < cookies.length; i += 1) {
    if (cookies[i].includes('affiliate=')) {
      return parseAffiliate(cookies[i].replace('affiliate=', ''));
    }
  }

  return null;
}

export const setAffiliateCookie = (info) => {
  if (!info || !info.name || !info.id) return;

  // To help keep the way we access the data consistent, we'll format the cookie
  // to be the same order as the url with the - as the separator.
  const affiliate = encodeURIComponent(`${info.name}-${info.id}-${info.type || ''}`);

  const currentDate = new Date();
  // Setting to 30 days to mimic referrals behavior
  currentDate.setTime(currentDate.getTime() + (30*24*60*60*1000));
  const expires = currentDate.toUTCString();

  document.cookie = `affiliate=${affiliate};expires=${expires};path=/`;
}
